import React from 'react';
import withStyles from '@mui/styles/withStyles';
import Typography from '@mui/material/Typography';
import Subtype from './Subtype';
import styles from './styles';
import Skeleton from '@mui/material/Skeleton';
import Card from 'react-bootstrap/Card';
import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import ListGroup from 'react-bootstrap/ListGroup';
import { sortTypes, sortSubtypes } from '../../utils/sortEquipmentTypes';

const Lists = ({ classes, loading, types, expanded }) => {
  if (!loading && types.length <= 0) {
    return (
      <div>
        <Typography variant="h2">No models match the search criteria.</Typography>
      </div>
    );
  }

  if (loading) {
    return <Placeholder />
  }

  return (
    <Container fluid>
      <Row>
        {types.sort(sortTypes).map(type => (
          <Col 
            md={4}
            key={type.equipment_type_id}
          >
            <Card
              style={{
                marginBottom: 10,
              }}
            >
              <Card.Body>
                <Card.Title><strong>{type.equipment_type_name}</strong></Card.Title>
              </Card.Body>
              <ListGroup 
                className="list-group-flush" 
                style={{
                  height: 400,
                  overflow: 'auto'
                }}
              >
                {type.subtypes.sort(sortSubtypes).map(subtype => (
                  <Subtype
                    key={subtype.equipment_sub_type_id}
                    classes={classes}
                    subtype={subtype}
                    expanded={expanded}
                  />
                ))}
              </ListGroup>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  );
}

export default withStyles(styles)(Lists);

function Placeholder() {
  return (
    <Container fluid style={{ minHeight: 500, margin: 15 }}>
      <Row>
        <Col 
          md={4}
        >
          <Skeleton width={340} height={150} />
        </Col>
        <Col 
          md={4}
        >
          <Skeleton width={340} height={150} />
        </Col>
        <Col 
          md={4}
        >
          <Skeleton width={340} height={150} />
        </Col>
      </Row>
    </Container>
  );
}